import { render, staticRenderFns } from "./BaseBlockTitle.vue?vue&type=template&id=07a5191f&"
import script from "./BaseBlockTitle.vue?vue&type=script&lang=js&"
export * from "./BaseBlockTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports